import React from "react";

const SkeletonCard = () => {
  return (
    <div className="card bg-base-100 shadow-sm border border-gray-100 animate-pulse">
      {/* Image Placeholder */}
      <div className="h-40 bg-gray-200 w-full rounded-t-xl"></div>
      
      <div className="p-4 space-y-3">
        {/* Title Placeholder */}
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        {/* Category Placeholder */}
        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
        
        {/* Price & Button Placeholder */}
        <div className="flex justify-between mt-4">
          <div className="h-6 bg-gray-200 rounded w-1/3"></div>
          <div className="h-8 bg-gray-200 rounded w-1/3"></div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;